import { createCrudActions } from '../utils/crudGenerator';

const formatPlayers = (data) => {
    if (!data) {
        return [];
    }
    const formatItem = (item) => ({
        ...item,
        label: `${item.name}`,
        value: item._id,
    });

    if (Array.isArray(data)) {
        return data.map(formatItem);
    }
    return formatItem(data);
};

export const {
    fetch: fetchPlayers,
    create: createPlayer,
    update: updatePlayer,
    delete: deletePlayers
} = createCrudActions('PLAYER', "Jugadore", formatPlayers);